/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function AIStartPrompt({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M12.244 10.3a.6.6 0 0 1 .6.6v1.15h1.15a.6.6 0 0 1 0 1.2h-1.15v1.15a.6.6 0 1 1-1.2 0v-1.15h-1.15a.6.6 0 1 1 0-1.2h1.15V10.9a.6.6 0 0 1 .6-.6Z" /><path stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} d="M2 2.837h12M2 7.75h12" /><path stroke="currentColor" strokeDasharray="3 2" strokeLinecap="round" strokeWidth={1.2} d="M2 12.662h6" /></svg>;
}
;